document.addEventListener("DOMContentLoaded", function() {
  // Find the slider container with the class 'swiper-bar-wrapper'
  var sliderContainer = document.querySelector('.swiper-bar-wrapper');
  if (!sliderContainer) return; // Exit if the container is not found

  // Get all slides within the container
  var slides = sliderContainer.querySelectorAll('.swiper-slide');
  if (slides.length === 0) return; // Exit if there are no slides

  var currentSlide = 0;       // Index of the current slide
  var slideInterval = null;   // Variable to store the interval ID
  var autoplayDelay = 3000;   // Delay for autoplay in milliseconds

  // Function to display the slide at the given index and hide others
  function showSlide(index) {
    slides.forEach(function(slide, i) {
      slide.style.display = (i === index) ? 'block' : 'none';
    });
  }

  // Function to start autoplay
  function startAutoplay() {
    // Immediately display the current slide
    showSlide(currentSlide);
    // Set an interval to switch to the next slide every autoplayDelay milliseconds
    slideInterval = setInterval(function() {
      currentSlide = (currentSlide + 1) % slides.length; // Move to the next slide in a loop
      showSlide(currentSlide);
    }, autoplayDelay);
  }

  // Function to stop autoplay if it is running
  function stopAutoplay() {
    if (slideInterval) {
      clearInterval(slideInterval);
      slideInterval = null;
    }
  }

  // Function to initialize the slider based on the window width
  function initSlider() {
    if (window.innerWidth < 768) {
      // On mobile devices: start autoplay if it's not already running
      if (!slideInterval) {
        startAutoplay();
      }
    } else {
      // On desktop devices: stop autoplay and show all slides
      stopAutoplay();
      slides.forEach(function(slide) {
        slide.style.display = 'block';
      });
    }
  }

  // Initialize the slider when the page loads
  initSlider();

  // Reinitialize the slider whenever the window is resized
  window.addEventListener('resize', function() {
    initSlider();
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach(function(link) {
    link.addEventListener("click", function(event) {
      event.preventDefault();

      
      const targetID = link.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetID);

      

      if (targetElement) {
        console.log(targetElement);
        
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function() {
  const originalParent = document.querySelector('.GWA-customer-loves')?.parentNode;

  function moveCustomerLoves() {
    const productEl = document.querySelector('.product');
    const lovesEl   = document.querySelector('.GWA-customer-loves');

    if (!productEl || !lovesEl) return;

    if (window.innerWidth < 768) {
      productEl.insertBefore(lovesEl, productEl.firstChild);
    } else {
      if (originalParent && !originalParent.contains(lovesEl)) {
        originalParent.appendChild(lovesEl);
      }
    }
  }

  moveCustomerLoves();
  window.addEventListener('resize', moveCustomerLoves);
});

